import { forkJoin, Observable } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../shared/models';
import { FormGroup, FormBuilder, Validators, NgForm, FormControl, ValidationErrors } from '@angular/forms';
import { ICountry } from '../../../shared/models/country.interface';
import { CountryService } from '../../../shared/services/country.service';
import { UserService } from '../../../shared/services';
import { UserRoleEnum } from '../../../shared/common/user-role.enum';
import { ToastyService } from 'ng2-toasty';
import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
@Component({
  selector: 'app-students-for-impact-edition',
  templateUrl: './students-for-impact-edition.component.html',
  styleUrls: ['./students-for-impact-edition.component.css']
})
export class StudentsForImpactEditionComponent implements OnInit {

  public user: User;
  public userDetailsForm: FormGroup;
  public passwordForm: FormGroup;
  public degreeDetailsForm: FormGroup;
  public selfEmployedDetailsForm: FormGroup;
  public userProfilForm: FormGroup;

  public countries: ICountry[] = [];
  public degreeCategories: any[] = [];
  public degreeYears: any[] = [];
  public siretValidation: { isValidate: boolean; message: string } | null = null;
  public siretValidating: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder,
    private countryService: CountryService, private userService: UserService,
    private toastyService: ToastyService, private studentsForImpactService: StudentsForImpactService) {
    this.user = this.route.snapshot.data['user'];

    if (!this.user || !this.user.id) {
      this.toastyService.error({
        title: 'Attention',
        msg: 'Impossible de charger les détails de l\'utilisateur.',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
      this.router.navigate(['/students-for-impact']);
      return;
    }

    // tslint:disable-next-line:max-line-length
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.userDetailsForm = formBuilder.group({
      'name': ['', [Validators.required]],
      'firstname': ['', [Validators.required]],
      'email': ['', [Validators.required, Validators.pattern(patternEmail)]],
      'mobile': [''],
      'birth_date': ['']
    });

    this.degreeDetailsForm = formBuilder.group({
      'institution': ['', [Validators.required]],
      'degree_category_id': ['', [Validators.required]],
      'degree_year_id': ['', [Validators.required]],
      'validity': ['']
    });

    this.selfEmployedDetailsForm = formBuilder.group({
      'siret': ['', [Validators.required, Validators.pattern(/^\d{14}$/)]]
    });

    this.userProfilForm = formBuilder.group({
      'details': ['']
    });

    this.passwordForm = formBuilder.group({
      'password': [''],
      'password_confirmation': ['']
    }, { validator: this.checkIfMatchingPasswords('password', 'password_confirmation') });

    this.countryService.getCountries().subscribe(
      data => {
        this.countries = this.move(data, data.indexOf(data.filter(country => country.alpha2Code === 'FR')[0]), 0);
      }
    );

    // Chargement des catégories et années de diplômes
    this.studentsForImpactService.getDegreeCategoriesFilters(true).subscribe(
      data => {
        // Transformer l'objet groupé en tableau plat
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          this.degreeCategories = [];
          Object.keys(data).forEach(key => {
            if (Array.isArray(data[key])) {
              this.degreeCategories = this.degreeCategories.concat(data[key]);
            }
          });
        } else {
          this.degreeCategories = Array.isArray(data) ? data : [];
        }
      }
    );

    this.studentsForImpactService.getDegreeYearsFilters(true).subscribe(
      data => {
        // Transformer l'objet groupé en tableau plat
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          this.degreeYears = [];
          Object.keys(data).forEach(key => {
            if (Array.isArray(data[key])) {
              this.degreeYears = this.degreeYears.concat(data[key]);
            }
          });
        } else {
          this.degreeYears = Array.isArray(data) ? data : [];
        }
      }
    );
  }

  ngOnInit() {
    console.log(this.user);
    this.userDetailsForm.addControl('address', new FormControl(this.user.user_adresses ?
      this.user.user_adresses.address_line_1 : '', [Validators.required]));
    this.userDetailsForm.addControl('post_code', new FormControl(this.user.user_adresses ?
      this.user.user_adresses.post_code : '', [Validators.required]));
    this.userDetailsForm.addControl('city', new FormControl(this.user.user_adresses ?
      this.user.user_adresses.city : '', [Validators.required]));
    this.userDetailsForm.addControl('country', new FormControl(this.user.user_adresses ?
      this.user.user_adresses.country_iso : '', [Validators.required]));
     

    this.userDetailsForm.patchValue({
      name: this.user.name,
      firstname: this.user.firstname,
      email: this.user.email,
      mobile: this.user.mob_phone,
      birth_date: this.user.birth_date ? new Date(this.user.birth_date).toISOString().slice(0, 10) : ''
    });

    this.degreeDetailsForm.patchValue({
      'institution': this.user.degree ? this.user.degree.institution : '',
      'degree_category_id': this.user.degree && this.user.degree.degree_category ? this.user.degree.degree_category.id : '',
      'degree_year_id': this.user.degree && this.user.degree.degree_year ? this.user.degree.degree_year.id : '',
      'validity': this.user.degree && this.user.degree.validity ? new Date(this.user.degree.validity).toISOString().slice(0, 10) : ''
    });

    this.selfEmployedDetailsForm.patchValue({
      'siret': this.user.self_employed ? this.user.self_employed.siret : ''
    });

    this.userProfilForm.patchValue({
      'details': this.user.details || ''
    });

    // Écouter les changements du SIRET pour validation en temps réel
    this.selfEmployedDetailsForm.get('siret').valueChanges.subscribe(value => {
      if (value && value.length === 14) {
        this.validateSiret(value);
      } else {
        this.siretValidation = null;
      }
    });
  }

  save(): void {
    const saveOperations: Observable<any>[] = [];
    let hasChanges = false;

    // Sauvegarder userDetailsForm et passwordForm (mécanique actuelle)
    if (this.userDetailsForm.dirty || this.passwordForm.dirty) {
      this.validateAllFormFields(this.passwordForm);
      this.validateAllFormFields(this.userDetailsForm);

      if (this.passwordForm.valid && this.userDetailsForm.valid) {
        hasChanges = true;
        const user: User = Object.assign(this.user, {
          email: this.userDetailsForm.value['email'],
          firstname: this.userDetailsForm.value['firstname'],
          name: this.userDetailsForm.value['name'],
          mob_phone: this.userDetailsForm.value['mobile'],
          birth_date: new Date(this.userDetailsForm.value['birth_date']).toUTCString(),
          user_adress: Object.assign({}, {
            address_line_1: this.userDetailsForm.value['address'],
            city: this.userDetailsForm.value['city'],
            post_code: this.userDetailsForm.value['post_code'],
            country_iso: this.userDetailsForm.value['country']
          })
        });

        saveOperations.push(this.userService.updatePassword(Object.assign({}, user, this.passwordForm.value)));
        saveOperations.push(this.userService.update(user));
      } else {
        this.toastyService.error({
          title: 'Attention',
          msg: 'Merci de corriger les erreurs dans les informations utilisateur',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
        return;
      }
    }

    // Sauvegarder userProfilForm (nouveau)
    if (this.userProfilForm.dirty) {
      hasChanges = true;
      saveOperations.push(this.saveProfile());
    }

    // Sauvegarder degreeDetailsForm (nouveau)
    if (this.degreeDetailsForm.dirty) {
      this.validateAllFormFields(this.degreeDetailsForm);
      if (this.degreeDetailsForm.valid) {
        hasChanges = true;
        saveOperations.push(this.saveDegree());
      } else {
        this.toastyService.error({
          title: 'Attention',
          msg: 'Merci de corriger les erreurs dans les informations d\'études',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
        return;
      }
    }

    // Sauvegarder selfEmployedDetailsForm (nouveau)
    if (this.selfEmployedDetailsForm.dirty) {
      this.validateAllFormFields(this.selfEmployedDetailsForm);
      if (this.selfEmployedDetailsForm.valid) {
        hasChanges = true;
        saveOperations.push(this.saveSelfEmployed());
      } else {
        this.toastyService.error({
          title: 'Attention',
          msg: 'Merci de corriger les erreurs dans les informations d\'indépendant',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
        return;
      }
    }

    if (!hasChanges) {
      this.toastyService.error({
        title: 'Attention',
        msg: 'Pas de changement détecté',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
      return;
    }

    // Exécuter toutes les opérations en parallèle
    forkJoin(saveOperations).subscribe(
      () => {
        this.toastyService.success({
          title: 'Félicitation',
          msg: 'Informations modifiées avec succès',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
        // Marquer tous les formulaires comme pristine
        this.userDetailsForm.markAsPristine();
        this.passwordForm.markAsPristine();
        this.degreeDetailsForm.markAsPristine();
        this.selfEmployedDetailsForm.markAsPristine();
        this.userProfilForm.markAsPristine();
      },
      (error) => {
        console.error('Erreur lors de la sauvegarde:', error);
        this.toastyService.error({
          title: 'Attention',
          msg: error.error && error.error.message ? error.error.message : 'Une erreur s\'est produite',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      }
    );
  }

  /**
   * Sauvegarde le profil utilisateur (details/motivation)
   */
  private saveProfile(): Observable<any> {
    return this.studentsForImpactService.saveProfile(this.user.id,this.userProfilForm.value['details'] || '').pipe(
      catchError(error => {
        console.error('Erreur saveProfile:', error);
        throw error;
      })
    );
  }

  /**
   * Sauvegarde les informations d'études
   */
  private saveDegree(): Observable<any> {
    return this.studentsForImpactService.saveDegree(
      this.user.id,
      this.degreeDetailsForm.value['institution'],
      this.degreeDetailsForm.value['degree_category_id'],
      this.degreeDetailsForm.value['degree_year_id'],
      this.degreeDetailsForm.value['validity'] || undefined
    ).pipe(
      catchError(error => {
        console.error('Erreur saveDegree:', error);
        throw error;
      })
    );
  }

  /**
   * Valide le SIRET via l'API INSEE
   */
  private validateSiret(siret: string): void {
    this.siretValidating = true;
    this.siretValidation = null;

    this.studentsForImpactService.validateSiret(siret).subscribe(
      (response: any) => {
        this.siretValidating = false;
        
        // La réponse contient directement { siret, isActive, ... } sans wrapper data
        console.log('Réponse validateSiret:', response);
        if (response && response.isActive === true) {
          this.siretValidation = { isValidate: true, message: 'SIRET valide' };
        } else {
          const message = 'SIRET invalide ou non vérifié';
          this.siretValidation = { isValidate: false, message };
        }
      },
      (err) => {
        this.siretValidating = false;
        this.siretValidation = { 
          isValidate: false, 
          message: 'Erreur lors de la vérification du SIRET' 
        };
        console.error('Erreur validateSiret:', err);
      }
    );
  }

  /**
   * Sauvegarde les informations d'indépendant
   */
  private saveSelfEmployed(): Observable<any> {
    return this.studentsForImpactService.saveSelfEmployed(this.user.id,this.selfEmployedDetailsForm.value['siret']).pipe(
      catchError(error => {
        console.error('Erreur saveSelfEmployed:', error);
        throw error;
      })
    );
  }

  /**
   * Validate all FormControl
   * @param formGroup FormGroup instance
   */
  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  private move(array: any[], from: number, to: number) {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  };

  private formsHaveChanges(...forms: FormGroup[]): boolean {
    let result = false;
    forms.forEach(form => {
      if (!!form && form.dirty) {
        result = true;
      }
    })
    return result;
  }

  isDisabled(): boolean {
    return !this.formsHaveChanges(this.userDetailsForm, this.degreeDetailsForm, this.passwordForm, this.selfEmployedDetailsForm, this.userProfilForm)
  }
}
